export default __webpack_public_path__ + "static/bahar-355644d2be31bf3b3c8d59db26266e25.png";